import TicketUpdateForm from '../TicketUpdateForm';

export default function TicketUpdate(props: any) {
  const {
    setBlockScreen,
    action,
    ticket_number,
    update_number = 'undefined' } = props

  return (
    <TicketUpdateForm
      setBlockScreen={setBlockScreen}
      action={action}
      ticket_number={ticket_number}
      update_number={update_number}
    />
  )
}